// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"3d401b3d","448":"511ad70e","456":"2fcf8183","480":"6bf5b372","944":"73a69b9d"}[chunkId] + ".chunk.js";
};